
	import {
		Vue,
		Component,
		Prop,
		PropSync,
		Watch,
		Inject,
	} from "vue-property-decorator";
	import Table from "@/components/base/table/body/TableMedia.vue";
	import RadioHeader from "@/components/base/table/header/RadioHeader.vue";
	import { Action, Getter, State } from "vuex-class";
	import { getImage } from "@/api/common";
	import Pagination from "@components/base/pagination/PcmPagination.vue";
	import Marquee from "@/components/semantics/Marquee.vue";
	import { deepClone, getParentArea } from "@/common/utils";
	import config from "@/config";
	import { Route } from "vue-router";
	@Component({
		name: "Media",
		components: {
			RadioHeader,
			Table,
			Marquee,
			Pagination,
		},
	})
	export default class Media extends Vue {
		@State("directCityList") private directCityList : any;
		@Getter("cityId") private cityId : any;
		@Getter("city") private city : any;
		@Action("policy/getPublicyList") private getPublicyList : any;
		area_option : any = [];
		tableData : any = [];
		btnList : any = [
			{
				label: "涉企动态",
				value: "涉企动态",
			},
			{
				label: "文字解读",
				value: "文字解读",
			},
			{
				label: "图片解读",
				value: "图片解读",
			},
			// {
			//   label: "政策汇编",
			//   value: "政策汇编",
			// },
			{
				label: "在线访谈",
				value: "在线访谈",
			},
		];
		active : any = 0;
		current1 : any = 1;
		pages1 : any = 0;
		total1 : any = 0;
		size1 : any = 16;
		current_option : any = {};
		created() {
			if (this.$route.query.index) {
				this.active = Number(this.$route.query.index);
			}
			this.getData();
		}
		// @Watch(`$route`)
		// handleRoutechange({ path, query }: any, from: any) {
		//   if (path == "/pcm/media" && query.index) {
		//     this.$router.go(0);
		//   }
		// }
		loading : boolean = false;
		clickMarquee(options : any) {
			options.addressCode ? options.addressCode : this.city.id;
			this.current_option = {
				addressCode: options.addressCode,
				departmentId: options.departmentId,
				nature: options.nature,
			};
			this.getData(1);
		}
		getData(type = 0) {
			this.loading = true;
			let options : any = {
				pageNumber: this.current1,
				pageSize: this.size1,
				bigClass: "解读",
				unscrambleType: this.btnList[this.active].value,
				order: "desc",
				sort: "releaseDate",
				locationAddressCode: this.city.locationAddressCode,
			};
			if (type === 1) {
				options = {
					...options,
					...this.current_option,
				};
			} else {
				if (!this.city.locationAddressCode) {
					options.addressCode = this.city.id;
				}
				options = {
					...options,
				};
			}
			this.getPublicyList(options)
				.then(({ code, result } : any) => {
					if (code === 200) {
						const { total, list, pages } = result;
						if (this.active === 1) {
							this.tableData = list.map((item : any) => {
								item.withPicturesUrl = null;
								return item;
							});
						} else {
							this.tableData = list.map((item : any) => {
								return item;
							});
						}
						this.total1 = total;
						this.pages1 = pages;
					}
				})
				.finally(() => (this.loading = false));
		}
		handleClickBtn(index : any) {
			this.active = index;
			/*     if (index == 3) {
			  location.href =
				"https://book.yunzhan365.com/nqtou/yzvv/mobile/index.html";
			} else  */
			/*if (index == 4) {
			  this.$router.push({
				path: "/pcm/online",
				query: { AddressCode: this.city.id },
			  });
			} else {
			  this.current = 1;
			  this.getData(0);
			}*/
			this.current1 = 1;
			this.getData(0);
		}
		toDetail({ id, originalAddress } : any) {
			// if (this.active === 3) {
			// 	window.open(originalAddress);
			// } else {
				
				
			// this.$router.push({
			// 	path: "/detail/text",
			// 	query: { textId: id },
			// });
			const routeObj =this.$router.resolve({
				path: "/detail/text",
				query: { textId: id },
			});
			window.open(routeObj.href, "_blank");
			
			// }

			// if (this.active === 0) {
			//   this.$router.push({
			//     path: "/detail/text",
			//     query: { textId: id },
			//   });
			// } else {
			//   this.$router.push({
			//     path: "/detail/img",
			//     query: { imgId: id },
			//   });
			// }
		}

		search(options : any) {
			this.current1 = 1;
			this.current_option = {
				...this.current_option,
				...options,
			};
			this.getData(1);
		}
		currentChange1(params : any) {
			this.current1 = params;
			this.getData(1);
		}
		sqdtTableRowStyle({ rowIndex }) {
			return {
				backgroundColor: rowIndex % 2 === 1 ? '#f5f7fa' : '#ffffff'
			}
		}

		sqdtTableCellStyle({ rowIndex }) {
			const isLastRow = rowIndex === this.tableData.length - 1
			return {
				padding: '20px 20px',
				border: 'none',
				borderBottom: isLastRow ? 'none' : '1px solid #ebeef5'
			}
		}
	}
